<template>
    <footer class="footer" />
</template>

<script>
    export default {
        name: "dashboardFooter"
    }
</script>

<style scoped>

</style>
